import { useForm } from "@mantine/form"
import { httpsCallable } from "firebase/functions"

import { useCloudFunction } from "../../../../hooks/useCloudFunction"
import { Attribute, DeviceDocument } from "../../../../contexts/devices-context"
import { AwsLambdaUpdateThingData } from "../../../../functions/aws/lambda/aws-lambda-updateThing"
import { firebase } from "../../../../services/firebase/firebase"
import { AwsLambdaUpdateGroupData } from "../../../../functions/aws/lambda/aws-lambda-updateGroup"
import { useLanguage } from "../../../../contexts/language-context"

export default (
    attrs: Record<"duration", Attribute> | undefined,
    organisation: string,
    group: string,
    device?: DeviceDocument,
) => {
    const { onStart, onSuccess, onError, processing } = useCloudFunction(
        device ? "aws-lambda-updateThing" : "aws-lambda-updateGroup",
    )
    const { L } = useLanguage()
    const form = useForm({
        initialValues: {
            durationPre: (attrs?.duration.value as [number, number] | undefined)?.[0] ?? null,
            durationPost: (attrs?.duration.value as [number, number] | undefined)?.[1] ?? null,
        },
    })

    const onSubmit = async (values: typeof form.values) => {
        onStart(L("Updating setting..."))

        const submittedValues = {
            ...values,
            durationPre: device?.type === "BeeMoni_RPI4" ? 0 : values.durationPre,
        }

        const module = {
            name: "camera",
            attributes: [
                ...((form.isDirty("durationPre") || form.isDirty("durationPost")) && attrs?.duration.mutable
                    ? [
                        {
                            name: "duration",
                            value:
                                submittedValues.durationPre === null && submittedValues.durationPost === null
                                    ? null
                                    : ([submittedValues.durationPre, submittedValues.durationPost] as [number, number]),
                        },
                    ]
                    : []),
            ] as Attribute[],
        }

        try {
            if (device) {
                await httpsCallable<AwsLambdaUpdateThingData>(
                    firebase.functions,
                    "aws-lambda-updateThing",
                )({
                    id: device.id,
                    group,
                    organisation,
                    module,
                })
            } else {
                await httpsCallable<AwsLambdaUpdateGroupData>(
                    firebase.functions,
                    "aws-lambda-updateGroup",
                )({
                    id: group,
                    organisation,
                    module,
                })
            }

            form.resetDirty(submittedValues)
            form.setValues(submittedValues)

            onSuccess()()
        } catch (error) {
            onError()(error)
        }
    }
    return {
        form,
        onSubmit,
        reset: form.reset,
        inheritSettings: () => form.setValues({ durationPre: null, durationPost: null }),
        processing,
    }
}
